import { apiBase } from "./base";

const apiBooks = {
	client: apiBase.get_client(),
	url: "/",

	getUnits() {
		return this.client.get(this.url + "kats/units/", apiBase.get_headers());
	},

	getExpensesTypes() {
		return this.client.get(this.url + "kats/expenses_types/", apiBase.get_headers());
	},

	getTerritorialBooks() {
		return this.client.get(this.url + "calc/territorial_books/", apiBase.get_headers());
	},

	getFilterTypes() {
		return this.client.get(this.url + "books/filter_types/", apiBase.get_headers());
	},

	getXmlShemas() {
		return this.client.get(this.url + "smetdocs/xml_shemas/", apiBase.get_headers());
	},
};

export default apiBooks;
